var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-footer__wrapper"},[_vm._t("above"),_vm._t("content"),_vm._t("below")],2)}
var staticRenderFns = []

export { render, staticRenderFns }